export interface Documents {
    ppa?: string;
    cap?: string;
    rdp?: string;
}
